export default __webpack_public_path__ + "static/media/store-2.c527aa46.jpg";